/**
 * Initialize Firebase Performance Monitoring and platform analytics hooks.
 * Call once after the default Firebase app exists.
 */

import type { FirebaseApp } from 'firebase/app';
import { getPerformance } from 'firebase/performance';
import {
  ensurePlatformAnalytics,
  registerPlatformGlobalErrorHandlers,
} from '../utils/platformAnalytics';

let initialized = false;

export async function initFirebaseObservability(_app: FirebaseApp): Promise<void> {
  if (initialized || typeof window === 'undefined') return;
  initialized = true;

  if (process.env.REACT_APP_DISABLE_OBSERVABILITY === '1') return;
  if (process.env.NODE_ENV === 'development') return;

  registerPlatformGlobalErrorHandlers();

  try {
    getPerformance(_app);
  } catch {
    // Performance Monitoring unavailable (browser, CSP, or missing appId).
  }

  await ensurePlatformAnalytics();
}
